import { Routes, Route, Navigate } from "react-router-dom";
import { ModuleErrorBoundary } from "@hub/ui/components/ErrorBoundary";
import { useAuth } from "@hub/auth";
import { PersonalDashboard } from "./components/PersonalDashboard";
import { TeamDashboard } from "./components/TeamDashboard";

function RequireRole({ roles, children }: { roles: string[]; children: React.ReactNode }) {
  const { user } = useAuth();
  if (!user || !roles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
}

export function DashboardRoutes() {
  return (
    <ModuleErrorBoundary moduleName="Dashboard">
      <Routes>
        <Route index element={<PersonalDashboard />} />
        <Route
          path="team"
          element={
            <RequireRole roles={["admin", "operator"]}>
              <TeamDashboard />
            </RequireRole>
          }
        />
      </Routes>
    </ModuleErrorBoundary>
  );
}
